import styled from 'styled-components';

export const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
`;

interface MainContentProps {
  sidebarExpanded: boolean;
}

export const MainContent = styled.div<MainContentProps>`
  flex-grow: 1;
  padding-left: ${(props) => (props.sidebarExpanded ? '250px' : '60px')};
  transition: padding-left 0.3s ease;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.backgroundColor};
  width: calc(100% - ${(props) => (props.sidebarExpanded ? '250px' : '60px')});
`;

export const ContentArea = styled.main`
  padding: 24px;
  margin-top: 60px;
  flex-grow: 1;
  overflow-y: auto;
`;
